/**
 * We added an alias in webpack for "reflux" to point at this file so that we
 * could continue using just "reflux" throughout the project.
 *
 * Why the direct path?
 * In order to prevent webpack from creating a circular reference in this file we
 * specified the exact path. The exact path causes webpack to bundle the reflux
 * dependency from the original node module instead of the alias.
 *
 * See: https://webpack.js.org/configuration/resolve/#resolve-alias where they
 * mention the use of the "$" inside of the webpack alias name for more details.
 */
import Reflux from 'reflux/src/index.js';
import RefluxPromise from 'reflux-promise';
import bluebird from 'bluebird';

Reflux.use(RefluxPromise(bluebird));

export default Reflux;
